import { CoreTagType } from '@featuring-corp/components';

import { avatarColorType } from '@featuring-corp/components/dist/core-avatar/type';

import { PlatformCode } from '@type/common';

export type ColorType = 'gray' | 'black' | 'red' | 'yellow' | 'green' | 'blue';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
type CategoryColorType = ColorType & 'secondary';

export const setWorkspaceColor = (code: string): ColorType | undefined => {
	if (!code) return;

	const key = code?.charCodeAt(0);

	if (key >= 48 && key <= 56) {
		return 'yellow';
	} else if (key === 57 || (key >= 65 && key <= 72)) {
		return 'blue';
	} else if (key >= 73 && key <= 81) {
		return 'green';
	} else if (key >= 82 && key <= 90) {
		return 'red';
	} else return 'black';
};
export const setProfileColor = (pk: number | string): ColorType => {
	let target = 0;

	if (typeof pk === 'string')
		target = +pk
			.charCodeAt(0)
			.toString()
			.split('')
			.reduce((a, b) => +a + +b, 0);
	else target = pk;
	const result = target % 4;

	if (result === 0) {
		return 'yellow';
	} else if (result === 1) {
		return 'blue';
	} else if (result === 2) {
		return 'green';
	} else if (result === 3) {
		return 'red';
	} else return 'black';
};

const getTotalCharCode = (text: string) => {
	return text.split('').reduce((acc, cur) => acc + cur.charCodeAt(0), 0);
};

/**
 * 구 디자인 시스템의 태그 컬러를 카테고리 명 기반으로 반환합니다.
 */
export const setCategoryColor = (name: string, _platform_code: PlatformCode) => {
	// const categoryMap = platformCategories[platform_code];
	// const categoryKeys = Array.from(categoryMap.keys());
	const charCode = getTotalCharCode(name);
	const idx = charCode % 4;
	if (idx === 0) {
		return 'yellow';
	} else if (idx === 1) {
		return 'blue';
	} else if (idx === 2) {
		return 'green';
	} else if (idx === 3) {
		return 'red';
	} else return 'blue';
};

/**
 * 새로운 디자인 시스템의 태그 컬러를 카테고리 명 기반으로 반환합니다.
 */
export const getCategoryTagColor = (
	category: string,
	_platform?: PlatformCode,
): CoreTagType => {
	// const categoryMap = platformCategories[platform];
	// const categoryKeys = Array.from(categoryMap.keys());
	const charCode = getTotalCharCode(category);
	// const idx = categoryKeys.indexOf(category) % 4;
	const idx = charCode % 4;

	if (idx === 0) {
		return 'magenta';
	}
	if (idx === 1) {
		return 'blue';
	}
	if (idx === 2) {
		return 'orange';
	}
	if (idx === 3) {
		return 'red';
	}

	return 'magenta';
};

const avatarColorList: avatarColorType[] = [
	'red',
	'orange',
	'yellow',
	'lightGreen',
	'green',
	'cyan',
	'teal',
	'lightBlue',
	'blue',
	'indigo',
	'purple',
	'magenta',
	'burgundy',
];

export const getAvatarColorType = (targetText?: string | number): avatarColorType => {
	if (!targetText) return 'gray';

	const charCode = typeof targetText === 'number' ? targetText : targetText.charCodeAt(0);
	const colorType = charCode % 13;

	return avatarColorList[colorType];
};
